import React from 'react';
import { Form, DatePicker } from 'antd';
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/sk_SK';
import { DATETIME_FORMAT_DATE } from '../../../../utils/helpers/CommonHelper';

//https://ant.design/components/date-picker/
const FormDate = ({
  label,
  name,
  rules,
  format = DATETIME_FORMAT_DATE,
  extra,
  ...rest
}) => {
  const form = Form.useFormInstance();

  const isInsideDatePickerPopup = (event) => {
    if (!event?.relatedTarget) {
      return false;
    }

    return Boolean(
      event.relatedTarget.closest?.('.ant-picker-dropdown') ||
        event.relatedTarget.closest?.('.ant-picker-panel') ||
        event.relatedTarget.closest?.('.ant-picker-cell'),
    );
  };

  // rc-picker can drop a typed value on blur if focus moves straight to
  // another picker before the keystroke is committed; re-apply it here.
  // Ignore blur events caused by clicking inside the calendar popup itself,
  // because those should not overwrite the value selected by the picker.
  const handleBlur = (event) => {
    if (isInsideDatePickerPopup(event)) {
      return;
    }

    const raw = event.target?.value?.trim();
    if (!raw) {
      return;
    }

    const parsed = dayjs(raw, [format, 'DD.MM.YYYY', 'DD.M.YYYY', 'D.MM.YYYY'], true);
    if (parsed.isValid()) {
      form.setFieldValue(name, parsed);
    }
  };

  return (
    <Form.Item label={label} name={name} rules={rules} extra={extra}>
      <DatePicker
        placeholder={` - `}
        format={format}
        locale={locale}
        onBlur={handleBlur}
        {...rest}
      />
    </Form.Item>
  );
};

export default FormDate;
